import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => createStyles({
    text: {
        opacity: 0.8,
    },
}));

export default useStyles;
